<template lang="html">
    <v-app>
        <div>
            <vue-headful title="슥삭" description="슥삭" />
            <Navbar></Navbar>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12 sm2>
                        <Tabbar :ismobile="ismobile" :pagename="pagename" :drawer="drawer" :userinfo="userinfo"></Tabbar>
                    </v-flex>
                    <v-flex :class="isMobile ? 'mx-auto mt-5 xs12': 'mx-auto mt-5 xs12 sm10'">
                        <v-container v-if="userinfo.authAdmin == 2" fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">이벤트 등록</span>
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">이벤트를 등록합시다.</span>

                                <v-text-field dense label="이벤트 제목" outlined hint="제목을 입력해주세요." class="mt-1 col-8" v-model="eventTitle" block></v-text-field>
                                <v-text-field dense label="이벤트 부제" outlined hint="부제를 입력해주세요." class="mt-1 col-8" v-model="eventSubtitle" block></v-text-field>
                                
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1 mt-1">이미지를 업로드 해주세요.</span>
                                <v-file-input dense accept="image/*" label="File input" class="mt-2 col-8" v-model="file" outlined></v-file-input>
                                <v-btn v-if="!isUploaded" class="ml-2 mt-2 bg-main-dark text-white" v-on:click="upload()">이미지 업로드</v-btn>
                                <v-btn v-else class="ml-2 mt-2 bg-main-dark-opac-15 text-main" outlined v-on:click="uploadInit()">이미지 초기화</v-btn>

                                <span class="col-12 pt-0 text-left rem-1 text-grey-1 mt-1">이벤트 URL을 입력해주세요.</span>
                                <v-text-field dense label="광고 URL 입력" outlined hint="URL을 입력해주세요." class="mt-5 col-8" v-model="eventUrl" block></v-text-field>

                                <span class="col-12 pt-0 text-left rem-1 text-grey-1 mt-1">이벤트 마감 날짜를 입력해주세요.</span>
                                    <v-col cols="8" class="px-1">
                                        <v-dialog
                                            ref="dateDialog"
                                            v-model="timeModal"
                                            :return-value.sync="eventEndDate"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="eventEndDate"
                                                    label="공고마감시간"
                                                    prepend-icon="access_time"
                                                    readonly
                                                    v-on="on"
                                                >
                                                </v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-if="timeModal"
                                                v-model="eventEndDate"
                                                full-width
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="timeModal = false">Cancel</v-btn>
                                                <v-btn text color="primary" @click="$refs.dateDialog.save(eventEndDate)">OK</v-btn>
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>
                                
                            </v-row>
                            <v-row>
                                <v-col cols="4" class="ml-0 mr-auto">
                                    <v-btn class="bg-main-dark text-white border-main-rounded5 rem-1_2" block :height="60" outlined v-on:click="registerEvent">이벤트 등록</v-btn>
                                </v-col>
                            </v-row>

    
                            <div style="height:100px;"></div>
    
                            <v-row>
                                <span class="col-12 rem-2 text-left">이벤트 조회</span>
                            </v-row>
    
                            <v-row v-if="events != null && events.length == 0" class="mt-5">
                                <span class="col-12 pt-0 text-left rem-1 text-grey-1">업로드된 이벤트가 없습니다.</span>
                            </v-row>
    
                            <v-row class="mt-5">
                                <v-col cols="12" md="4" v-for="(event, index) in events">
                                    <v-card height="450" outlined elevation="5" class="">
                                        <v-img height="200" width="100%" :src="event.photoUrl"></v-img>
                                        <v-card-title>{{event.eventTitle}}</v-card-title>
                                        <v-card-subtitle class="text-left py-0">이벤트 부제: {{event.eventSubtitle}}</v-card-subtitle>
                                        <v-card-subtitle class="text-left py-0">이벤트 번호: {{event.eventIdx}}</v-card-subtitle>
                                        <v-card-subtitle class="text-left py-0">이벤트 URL: <a :href="event.eventUrl" target="_blank">{{event.eventUrl}}</a></v-card-subtitle>
                                        <v-card-subtitle class="text-left py-0">마감날짜: {{event.eventEndDate.substring(0, 10)}}</v-card-subtitle>
                                        <v-dialog v-model="adminDeleteDialog[index]" max-width="290">
                                            <template v-slot:activator="{ on }">
                                                <v-row>
                                                    <v-btn class="bg-main text-white border-rounded30 mx-auto" style="inline-block" :height="30" v-on="on">
                                                        <span>삭제</span>
                                                    </v-btn>
                                                </v-row>
                                            </template>
                                            <v-card>
                                                    <v-card-title>주의</v-card-title>
                                                    <v-card-text>
                                                        <span class="mt-5">정말 삭제하시겠습니까?</span>
                                                    </v-card-text>
                                                    <v-card-actions>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="text-main" text @click="adminDelete(event.eventIdx)">예</v-btn>
                                                        <v-btn color="text-grey-1" text @click="adminDeleteDialog.splice(index, 1, false)">아니요</v-btn>
                                                    </v-card-actions>
                                            </v-card>
                                        </v-dialog>
                                    </v-card>
                                </v-col>


                            </v-row>

                        </v-container>

                        <v-container v-else-if="userinfo.authAdmin != 2" fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">권한이 없습니다. 로그인 해주세요.</span>
                            </v-row>
                        </v-container>

                        <v-container v-else fluid class="px-5" style="min-height:1200px">
                            <v-row>
                                <span class="col-12 mt-5 text-left rem-2">로딩중...</span>
                            </v-row>
                        </v-container>
                        <Footer></Footer>
                    </v-flex>
                </v-layout>
    
            </v-container>

    
        </div>
    </v-app>
</template>

<script>
import Navbar from '../components/Navbar.vue'
import Tabbar from '../components/Tabbar.vue'
import Footer from '../components/Footer.vue'
import { mapGetters } from 'vuex'

export default {
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize()

        this.cur = this.$route.query.cur
        this.category = this.$route.query.category
        if (this.cur == null) this.cur = 1
        else {
            if (this.cur < 1) this.cur = 1
        }
        if (this.category == null) {
            this.tab = 0
        } else {
            this.tab = Number(this.category) - 100
        }
        this.getEvents()
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    data() {
        return {
            pagename: 2,
            window: {
                width: 0,
                height: 0
            },
            ismobile: false,
            drawer: false,
            group: null,

            events: [],

            eventTitle: '',
            eventSubtitle: '',
            photoUrl: '',
            eventUrl: '',
            eventEndDate: '',

            isUploaded: false,

            timeModal: false,
            adminDeleteDialog: [],

        }
    },
    computed: {
        ...mapGetters({
            userinfo: 'getUserInfo'
        })
    },
    components: {
        Navbar,
        Tabbar,
        Footer,
    },
    watch: {
        group() {
            this.drawer = false
        }
    },
    methods: {
        handleResize() {
            this.window.width = window.innerWidth;
            if (this.window.width <= 500) {
                this.ismobile = true
            } else {
                this.ismobile = false
            }
            this.window.height = window.innerHeight;
        },
        registerEvent() {
            if (this.eventTitle == '') {
                alert('이벤트 제목을 입력해주세요.')
            } else if (this.photoUrl == '') {
                alert('이벤트 이미지를 등록해주세요.')
            } else if (this.eventEndDate == '') {
                alert('이벤트 마감날짜를 등록해주세요.')
            } else {
                this.$http.post('/api/events', {
                        headers: { 'Content-type': 'application/x-www-form-urlencoded', },
                        eventTitle: this.eventTitle,
                        eventSubtitle: this.eventSubtitle,
                        photoUrl: this.photoUrl,
                        eventUrl: this.eventUrl,
                        eventEndDate: this.eventEndDate
                    })
                    .then(response => {
                        if (response.data.status == 200) {
                            alert('이벤트 등록 완료')
                            window.location.reload()
                        } else {
                            alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                            this.$store.dispatch('postLogout')
                        }
                    })
                    .catch(error => {
                        console.log('server error', error)
                    })
            }
        },
        adminDelete(eventIdx) {
            this.$http.delete(`/api/events/${eventIdx}`)
                .then((response) => {
                    if (response.data.status == 200) {
                        alert('삭제 완료')
                        window.location.reload()
                    } else {
                        alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                        this.$store.dispatch('postLogout')
                    }
                })
        },
        upload() {
            if (this.file == null) {
                alert('사진을 등록해주세요')
                return
            }
            var fd = new FormData()
            fd.append('imgFile', this.file, 'filename.jpg')

            this.$http.post(`/api/photos/reg`, fd)
                .then((response) => {
                    if (response.data.status == 200) {
                        console.log(response.data.data);
                        this.photoUrl = response.data.data.photoUrl.original
                        this.isUploaded = true
                        alert('업로드 완료!')

                    } else {
                        alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                        this.$store.dispatch('postLogout')
                    }
                }).catch(error => {
                    console.log(error)
                })
        },
        uploadInit() {
            this.photoUrl = '',
            this.isUploaded = false
        },
        getEvents() {
            this.$http.get('/api/events')
                .then((response) => {
                    if (response.data.status == 200) {
                        this.events = response.data.data.events

                        this.adminDeleteDialog = []
                        for(var i = 0; i < this.events.length; i++){
                            this.adminDeleteDialog.push(false)
                        }
                    } else {
                        alert('로그아웃 되었습니다. 다시 로그인해주세요.')
                        this.$store.dispatch('postLogout')
                    }
                })
        },
    }
}
</script>

<style lang="css">

</style>


// WEBPACK FOOTER //
// src/pages/AllEvents.vue